<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-reminder-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Reminder
            </h4>
          </div>

          <loading-spinner v-if="loading"></loading-spinner>

          <div v-else class="modal-body">
            <TextareaFormGroup
                v-model="data.text"
                name="text"
                label="Text"
                :error="getError('text')"
            />

            <SelectFormGroup
                v-model="data.priority"
                name="priority"
                label="Priority"
                :error="getError('priority')"
                :options="[{value: 'high', label: 'High'}, {value: 'medium', label: 'Medium'}, {value: 'low', label: 'Low'}]"
            />

            <DateFormGroup
                v-model="data.remind_at"
                name="remind_at"
                label="Remind At"
                :error="getError('remind_at')"
                format="DD.MM.YYYY HH:mm"
                original-format="YYYY-MM-DD HH:mm"
            />

            <TypeaheadFormGroup
                v-model="data.user_id"
                name="user_id"
                label="User"
                endpoint="/api/v2/users"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.full_name"
                :load-initial="true"
            />

            <MultiSelectFormGroup
                :value="data.portals.map(portal => portal.id)"
                name="portals"
                label="Portals"
                :error="(errors.portals || [])[0]"
                :options="portalOptions"
                @input="data.portals = $event.map(id => ({id}))"
            />

            <SelectFormGroup
                v-model="data.project_id"
                name="project_id"
                label="Project"
                :error="getError('project_id')"
                :options="projectOptions"
                :nullable="true"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import store from '@/store'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Block/Textarea'
import MultiSelectFormGroup from "../../../components/FormGroups/Block/MultiSelect.vue";
import TypeaheadFormGroup from "../../../vendor/forms/FormGroups/Block/Typeahead.vue";

export default {
  components: {TypeaheadFormGroup, MultiSelectFormGroup, DateFormGroup, LoadingSpinner, SelectFormGroup, TextareaFormGroup},

  mixins: [Errors],

  props: ['subject'],

  data() {
    return {
      data: {
        priority: 'medium',
        remind_at: moment().add(1, 'hour').startOf('hour').format('YYYY-MM-DD HH:mm'),
        user_id: store.user.id,
        project_id: null,
        portals: []
      },

      loading: true,

      projects: null,
      portals: null,

      shared: store
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  watch:{
    'data.portals'() {
      if (!this.data.portals.map(portal => portal.id).includes(this.project?.attributes.portal_id)) {
        this.data.project_id = null
      }
    }
  },

  computed: {
    projectOptions() {
      return this.projects
          .filter(project =>  this.data.portals.length === 0 || this.data.portals.map(portal => portal.id).includes(project.attributes.portal_id))
          .map(project => ({value: project.id, label: project.attributes.portal_name + ' - ' +project.attributes.project_category_name + ' - ' + project.attributes.name}))
    },

    portalOptions() {
      return this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
    },

    project() {
      return this.projects.find(project => project.id === this.data.project_id)
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    load() {
      Promise.all([
        http.get('/api/v2/projects',{'filter[status]': 'active'}),
        http.get('/api/v2/portals'),
      ]).then(responses=> {
        this.projects = responses[0].data.data
        this.portals = responses[1].data.data

        this.loading = false
      })
    },

    submit() {
      http.post('/api/v2/reminders', {
        ...this.data,
        subject_id: this.subject.data.id.toString(),
        subject_type: this.subject.data.type,
        remind_at: this.data.remind_at + ':00',
      })
          .then(() => {
            notify.success('The reminder was saved')

            this.$emit('created')

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {
        priority: 'medium',
        remind_at: moment().add(1, 'hour').startOf('hour').format('YYYY-MM-DD HH:mm'),
        user_id: store.user.id,
        portals: []
      }
    }
  }
}
</script>
